module.exports = __webpack_public_path__ + "img/home_8.d46ec186.png";